import { ChangeDetectionStrategy, Component } from '@angular/core';

import { OUTAGE_COPY } from '@common/util/outage.util';

/**
 * AIWB-1175 — shown after recovery when a write may or may not have reached the server.
 * The handlers are supplied by OutageService through SystemNotificationConfig.componentData.
 */
@Component({
  selector: 'app-outage-uncertain-prompt',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './outage-uncertain-prompt.component.html',
  styleUrls: ['./outage-screen.component.scss'],
})
export class OutageUncertainPromptComponent {
  onSendAgain: () => void = () => undefined;
  onDontSend: () => void = () => undefined;
  protected readonly copy = OUTAGE_COPY;
}
